import { render } from "./CampaignImpactDashboard.vue?vue&type=template&id=3ce174aa&scoped=true"
import script from "./CampaignImpactDashboard.vue?vue&type=script&lang=js"
export * from "./CampaignImpactDashboard.vue?vue&type=script&lang=js"

import "./CampaignImpactDashboard.vue?vue&type=style&index=0&id=3ce174aa&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce174aa"]])

export default __exports__